import React, { useEffect } from 'react'
import { DataLayerEventName } from '@news-mono/web-common'
import { ArticleBlockContent } from '../../publication'
import { mappedPublicationPropsToGa4 } from '../../__helpers'
import { PublicationProps } from './Publication.props'

export function ShorthandPublication(
    props: Pick<PublicationProps, 'onEvent' | 'adState' | 'data' | 'log'>,
) {
    const publication = props.data
    const content = publication.content

    const articleAvailablePayload = mappedPublicationPropsToGa4(publication)

    const { onEvent } = props
    useEffect(() => {
        if (articleAvailablePayload) {
            onEvent({
                type: DataLayerEventName.articleAvailable,
                originator: 'TheNightlyShorthandPublication',
                payload: articleAvailablePayload,
            })
        }
    }, [articleAvailablePayload, onEvent])

    return (
        <>
            {content && (
                <ArticleBlockContent
                    blocks={content}
                    onEvent={props.onEvent}
                    log={props.log}
                    adUnitPath={props.adState.targeting.adUnitPath}
                />
            )}
        </>
    )
}
